module.exports = __webpack_public_path__ + "img/155615.a025777c.jpg";